import React from 'react';
import { useLocation } from 'react-router-dom';
import { getHelpContext, HelpContext } from './helpConfig';

interface SpecificHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  context: string;
}

export const SpecificHelpModal: React.FC<SpecificHelpModalProps> = ({
  isOpen,
  onClose,
  context
}) => {
  // Solo mostramos los consejos, sin tabs
  const location = useLocation();
  
  // Obtener el contexto de ayuda basado en la ruta actual o el contexto proporcionado
  const helpContext = getHelpContext(context) || getHelpContext(location.pathname);
  

  
  if (!isOpen || !helpContext) {

    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#111827',
        borderRadius: '16px',
        maxWidth: '600px',
        width: '100%',
        maxHeight: '80vh',
        overflow: 'hidden',
        border: '2px solid #374151',
        position: 'relative'
      }}>
        {/* Header */}
        <div style={{
          backgroundColor: '#1F2937',
          padding: '24px',
          borderBottom: '1px solid #374151',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{
            color: '#F9FAFB',
            margin: 0,
            fontSize: '24px',
            fontWeight: 700
          }}>
            Ayuda - {helpContext.title}
          </h2>
          
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '18px',
              right: '18px',
              background: 'none',
              border: 'none',
              fontSize: '28px',
              cursor: 'pointer',
              color: '#B0BEC5',
              padding: '4px',
              borderRadius: '4px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2d3236';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#B0BEC5';
            }}
          >
            ×
          </button>
        </div>

        {/* Content - Solo Consejos */}
        <div style={{ lineHeight: '1.7', fontSize: '16px', color: '#F3F4F6' }}>
          <div style={{ padding: '24px' }}>
            <h3 style={{ 
              color: '#34D399', 
              marginBottom: '20px', 
              fontSize: '22px', 
              fontWeight: 700,
              textAlign: 'center'
            }}>
              Guía de {helpContext.title}
            </h3>
              
            <div style={{
              backgroundColor: '#1E293B',
              borderRadius: '12px',
              padding: '24px',
              border: '1px solid #34D399'
            }}>
              <ul style={{ margin: 0, paddingLeft: '20px' }}>
                {helpContext.quickTips.map((tip, index) => (
                  <li key={index} style={{ 
                    marginBottom: '12px',
                    fontSize: '16px',
                    lineHeight: '1.6'
                  }}>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
            
            <div style={{
              marginTop: '24px',
              padding: '16px',
              backgroundColor: '#0F172A',
              borderRadius: '8px',
              border: '1px solid #60A5FA',
              color: '#E0F2FE'
            }}>
              <p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}>
                💡 <strong>Tip:</strong> Estos consejos te ayudarán a aprovechar al máximo {helpContext.title.toLowerCase()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
